import React from "react";
import "../../css/components/controls/HrnbAlert.css";

export default function HrnbAlert({ type = "danger", children, style, ...props }) {
    // type: "danger" | "success" | "info" | "warning"
    return (
        <div
            className={`hrnb-alert hrnb-alert--${type}`}
            style={style}
            {...props}
        >
            {children}
        </div>
    );
}
